import CandidateCard from './CandidateCard.component';

export default CandidateCard;
